import { Button } from '@cfm-media/pwa-ui-components';

export function ErrorPage({ title, body, icon, buttonText, link }) {
  return (
    <div className="mt-5">
      <div className="max-w-5xl mx-auto px-6 sm:px-10 text-center">
        <span className={`icon ${icon} block text-brand-1 text-5xl mb-4`} />

        <div className="text-xl text-brand-1 font-semibold mb-4">{title}</div>

        <p className="mb-6">{body}</p>

        <Button title={buttonText} variant="primary" link="/" />
      </div>
    </div>
  );
}
